<div class="container">
    <mat-tab-group>
        <mat-tab label="{{ 'visibility.labels.accountConfiguration' | translate }}">
            <ng-template matTabContent>
                <div>
                    <project-visibility> </project-visibility>
                </div>
            </ng-template>
        </mat-tab>
        <mat-tab *ngIf="showSecondTab" label="{{ 'visibility.labels.visibilityGroup' | translate }}">
            <ng-template matTabContent>
                <div>
                    <project-visibility-group> </project-visibility-group>
                </div>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</div>